var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('contact-page'),_vm._v(" "),_c('submit-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }